import React from 'react';
import WhiteContainer from '../../../components/containers/WhiteContainer';
import List from '../../../components/list/List';
import Loading from '../../../components/loading/Loading';
import text, { formatCurrency } from '../../../text';
import { usePaymentContext } from '../../pages/payment';
import ChargeItem from './ChargeItem';

const ProductInvoice = () => {
  const {
    job,
    isJobLoading,
    numBillableItems,
    cardHeading,
    cartItemsAutomatic,
  } = usePaymentContext();
  const quote = job?.quote;

  return (
    <WhiteContainer className='Invoice position-relative'>
      {isJobLoading ? (
        <div className='position-absolute overlay-loader-container'>
          <Loading />
        </div>
      ) : null}
      {!quote ? null : (
        <>
          <h6 className='green-1 font-weight--600 mb-0'>
            <span className='mr-1'>
              {numBillableItems - (numBillableItems > 1 ? 1 : 0)}.
            </span>{' '}
            <span>
              {text('_invoiceType', {
                prefix: cardHeading,
                type: text('Data in the Database'),
              })}
            </span>
          </h6>
          <div style={{ paddingLeft: '20px', paddingRight: '16px' }}>
            <List>
              {cartItemsAutomatic?.map((charge, i) => (
                <ChargeItem key={i} charge={charge} />
              ))}

              {quote.discounts.map((discount, i) => (
                <List.Item
                  className='discount font-pink pl-3 pt-1 font-italic'
                  key={i}
                  description={discount.display_name}
                  value={`—${formatCurrency(
                    discount.price?.subtotal,
                    quote.currency.name,
                    quote.currency.scale_factor,
                    {},
                    true
                  )}`}
                />
              ))}
            </List>
          </div>
        </>
      )}
    </WhiteContainer>
  );
};

export default ProductInvoice;
